module.exports = "\r\n<div class=\"page-map\" id=\"map\">\r\n</div>\r\n\r\n<ui-view></ui-view>";